import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import {GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {AttendanceActionTypes} from "../../../AppLocals/Course";

export const renderCourseClassAttendance = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const {total_students, total_attendance, subject, number_of_sessions} = item ?? {}
    const percent_session = ((total_attendance / total_students) * 100).toFixed(1)
    let color

    if (percent_session < 50.0) {
        color = 'text-red-500'
    } else if (50.0 <= percent_session && percent_session < 74.9) {
        color = 'text-blue-500'
    } else if (percent_session >= 75.0) {
        color = 'text-green-500'
    } else {
        color = 'text-color-300'
    }

    return (
        <Translate key={index}>
            {(t) => (
                <div className="px-3 py-2 flex flex-col background hover:shadow-md hover:scale-2xs rounded-xl custom-item-render relative">
                    <div className="flex flex-col flex-1">
                        <div
                            onClick={() => {
                                handleAction(AttendanceActionTypes.DETAIL, item)
                            }}
                            className="flex items-center gap-2 mr-6">
                            <span className="font-normal text-color-400">
                                {`${index + 1}. `}
                            </span>
                            <span className="flex-1 font-bold text-base text-color-000 hover:text-primary max-lines-1 cursor-pointer">
                                {getTitle(item)}
                            </span>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 italic">
                            {renderIf(
                                subject,
                                <div className="flex items-center gap-1 text-xs">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="text-color-400">
                                        {`${t('subjects')} : `}
                                    </span>
                                    <span className="font-semibold text-color-100">
                                        {`${getTitle(subject)} (${number_of_sessions} ${t('sessions')})`}
                                    </span>
                                </div>
                            )}
                            {renderIf(
                                total_students,
                                <div className="flex items-center gap-1 text-xs">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="text-color-500">
                                        {`${t('attendance count')} : `}
                                    </span>
                                    <span className={classNames("font-semibold", color)}>
                                        {total_attendance}/{total_students} {` ( ${percent_session}% )`}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                    {renderIf(
                        item?.course_class?.edit && renderContextMenu,
                        <div className="absolute top-5 right-5 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            )}
        </Translate>
    )
}
